// index.js
"use strict"

class Api {
    constructor() {
        this.endpoint = "https://app.ecomotori.net/restfull";
    }

    initMap(key, callback) {
        const apiUrl = new URL(this.endpoint + "/capabilities");
        const params = {
            key: key
        };

        apiUrl.search = new URLSearchParams(params);
        fetch(apiUrl, {mode: "cors"})
            .then(res => res.json())
            .then(
                res => {
                    callback(false, res);
                },
                error => {
                    callback(error);
                }
            );
    }

    getStations(position, fuel, range, filters, dist, callback) {
        const apiUrl = new URL(this.endpoint + "/distributori");
        const params = {
            v: 2,
            posgps: `${position.lat};${position.lng}`,
        };

        if (fuel) params.carburante = fuel;
        if (range) params.range = range;
        if (dist) params.show_dist = 1;

        if (filters) {
            if (filters.filtro_bestprice) {
                params.filtro_bestprice = 1;
            }
            if (filters.filtro_biometano) {
                params.filtro_biometano = 1;
            }
            if (filters.filtro_selfservice) {
                params.filtro_selfservice = 1;
            }
            if (filters.filtro_autostradali) {
                params.filtro_autostradali = 1;
            }
            if (filters.filtro_hiperformance) {
                params.filtro_hiperformance = 1;
            }
        }

        apiUrl.search = new URLSearchParams(params);
        fetch(apiUrl, {mode: "cors"})
            .then(res => res.json())
            .then(
                res => {
                    callback(false, res);
                },
                error => {
                    callback(error);
                }
            );
    }

    getCountries(fuel, filters, callback) {
        const apiUrl = new URL(this.endpoint + "/nazioni/" + fuel);
        var params = {};

        if (filters) {
            if (filters.filtro_bestprice) {
                params.filtro_bestprice = 1;
            }
            if (filters.filtro_biometano) {
                params.filtro_biometano = 1;
            }
            if (filters.filtro_selfservice) {
                params.filtro_selfservice = 1;
            }
            if (filters.filtro_autostradali) {
                params.filtro_autostradali = 1;
            }
            if (filters.filtro_hiperformance) {
                params.filtro_hiperformance = 1;
            }
        }

        apiUrl.search = new URLSearchParams(params);
        fetch(apiUrl, {mode: "cors"})
            .then(res => res.json())
            .then(
                res => {
                    callback(false, res.nazioni);
                },
                error => {
                    callback(error);
                }
            );
    }

    getRegions(position, fuel, range, filters, callback) {
        const apiUrl = new URL(this.endpoint + "/regioni/" + fuel);
        const params = {
            posgps: `${position.lat};${position.lng}`,
        };

        if (range) params.range = range;

        if (filters) {
            if (filters.filtro_bestprice) {
                params.filtro_bestprice = 1;
            }
            if (filters.filtro_biometano) {
                params.filtro_biometano = 1;
            }
            if (filters.filtro_selfservice) {
                params.filtro_selfservice = 1;
            }
            if (filters.filtro_autostradali) {
                params.filtro_autostradali = 1;
            }
            if (filters.filtro_hiperformance) {
                params.filtro_hiperformance = 1;
            }
        }

        apiUrl.search = new URLSearchParams(params);
        fetch(apiUrl, {mode: "cors"})
            .then(res => res.json())
            .then(
                res => {
                    res.regioni.forEach(function (part, index, theArray) {
                        theArray[index].position.lat = parseFloat(theArray[index].position.lat);
                        theArray[index].position.lng = parseFloat(theArray[index].position.lng);
                    });
                    callback(false, res.regioni);
                },
                error => {
                    callback(error);
                }
            );
    }

    getRegion(country, region, fuel, callback) {
        const apiUrl = new URL([this.endpoint, "regione", country, region, fuel].join("/"));
        fetch(apiUrl, {mode: "cors"})
            .then(res => res.json())
            .then(
                res => {
                    callback(false, res.regione);
                },
                error => {
                    callback(error);
                }
            );
    }

    getProvinces(position, fuel, range, filters, callback) {
        const apiUrl = new URL(this.endpoint + "/province/" + fuel);
        const params = {
            posgps: `${position.lat};${position.lng}`,
        };
        if (range) params.range = range;

        if (filters) {
            if (filters.filtro_bestprice) {
                params.filtro_bestprice = 1;
            }
            if (filters.filtro_biometano) {
                params.filtro_biometano = 1;
            }
            if (filters.filtro_selfservice) {
                params.filtro_selfservice = 1;
            }
            if (filters.filtro_autostradali) {
                params.filtro_autostradali = 1;
            }
            if (filters.filtro_hiperformance) {
                params.filtro_hiperformance = 1;
            }
        }

        apiUrl.search = new URLSearchParams(params);
        fetch(apiUrl, {mode: "cors"})
            .then(res => res.json())
            .then(
                res => {
                    res.province.forEach(function (part, index, theArray) {
                        theArray[index].position.lat = parseFloat(theArray[index].position.lat);
                        theArray[index].position.lng = parseFloat(theArray[index].position.lng);
                    });
                    callback(false, res.province);
                },
                error => {
                    callback(error);
                }
            );
    }

    getProvince(country, region, province, fuel, filters, callback) {
        const apiUrl = new URL([this.endpoint, "provincia", country, region, province, fuel].join("/"));
        fetch(apiUrl, {mode: "cors"})
            .then(res => res.json())
            .then(
                res => {
                    callback(false, res.provincia);
                },
                error => {
                    callback(error);
                }
            );
    }

    postStation(sender, notes, callback) {
        const apiUrl = new URL(this.endpoint + "/distributore");
        const params = {
            segnalatore: sender,
            note: notes
        };

        fetch(apiUrl, {method: 'post', mode: "cors", body: JSON.stringify(params)})
            .then(res => res.json())
            .then(
                res => {
                    callback(false, res);
                },
                error => {
                    callback(error);
                }
            );
    }

    getStation(id, fuel, callback) {
        const apiUrl = new URL(this.endpoint + "/distributore/" + id + "/" + fuel);
        const params = {
            v: 2,
        };
        apiUrl.search = new URLSearchParams(params);
        fetch(apiUrl, {mode: "cors"})
            .then(res => res.json())
            .then(
                res => {
                    callback(false, res);
                },
                error => {
                    callback(error);
                }
            );

    }

    getNews(country, fuel, callback) {
        const apiUrl = new URL(this.endpoint + "/newsdistributori/" + country + "/" + fuel + "/30");
        fetch(apiUrl, {mode: "cors"})
            .then(res => res.json())
            .then(
                res => {
                    callback(false, res.newsdistributori);
                },
                error => {
                    callback(error);
                }
            );
    }

    getAnalytics(country, state, city, fuel, callback) {
        var url_components = [this.endpoint, 'statistichetemporali', fuel];

        if (country) url_components.push(country);
        if (state) url_components.push(state);
        if (city) url_components.push(city);

        const apiUrl = new URL(url_components.join('/'));
        fetch(apiUrl, {mode: "cors"})
            .then(res => res.json())
            .then(
                res => {
                    callback(false, res.statistichetemporali);
                },
                error => {
                    callback(error);
                }
            );
    }

    getPrices(country, state, city, fuel, callback) {
        var url_components = [this.endpoint, 'statistiche', fuel];

        if (country) url_components.push(country);
        if (state) url_components.push(state);
        if (city) url_components.push(city);

        const apiUrl = new URL(url_components.join('/'));
        fetch(apiUrl, {mode: "cors"})
            .then(res => res.json())
            .then(
                res => {
                    callback(false, res.statistiche);
                },
                error => {
                    callback(error);
                }
            );
    }

    postPrice(station_id, value, valueself, fuel, callback) {
        var url_components = [this.endpoint, 'segnalaprezzo', station_id, fuel];

        const apiUrl = new URL(url_components.join('/'));
        const params = {
            prezzo: value,
            prezzoself: valueself
        };

        fetch(apiUrl, {method: 'put', mode: "cors", body: JSON.stringify(params)})
            .then(res => res.json())
            .then(
                res => {
                    callback(false, res)
                },
                error => {
                    callback(error)
                }
            );
    }

    getGeocode(lat, lng, callback) {
        var url_components = [this.endpoint, 'nearest', lat, lng];

        const apiUrl = new URL(url_components.join('/'));
        fetch(apiUrl, {mode: "cors"})
            .then(res => res.json())
            .then(
                res => {
                    callback(false, res.nearest)
                },
                error => {
                    callback(error)
                }
            )
    }
}

export default new Api()
